import { useMemo } from "react";
import type { ServiceEntryType } from "@bmi/payload-types/dist/src/types/serviceEntryType";
import { useConfig } from "../../../contexts/ConfigProvider";
import { createMarker } from "../helpers";
import type { Service } from "../../Service";
import type { MarkerOptionsWithData } from "@bmi-digital/components/google-api";
import type { GeocoderResult as GoogleGeocoderResult } from "@bmi-digital/components/dist/google-api/GoogleApi";

type UseMarkers = (props: {
  showResultList: boolean;
  filteredRoofers: Service[];
  pagedFilteredRoofers: Service[];
  selectedRoofer: Service | null;
  activeSearchString: string;
  activeLocation: GoogleGeocoderResult | undefined;
  type: ServiceEntryType;
}) => MarkerOptionsWithData<Service>[];

const useMarkers: UseMarkers = ({
  activeSearchString,
  showResultList,
  filteredRoofers,
  pagedFilteredRoofers,
  selectedRoofer,
  activeLocation,
  type
}) => {
  const { disableDefaultMapPins } = useConfig();

  return useMemo(() => {
    if (!showResultList) {
      return [];
    }

    const isFindAMerchant = type === "Merchant";

    if (
      disableDefaultMapPins &&
      isFindAMerchant &&
      !activeSearchString &&
      !activeLocation
    ) {
      return selectedRoofer
        ? [selectedRoofer].map(createMarker(selectedRoofer))
        : [];
    }

    if (
      disableDefaultMapPins &&
      isFindAMerchant &&
      (activeSearchString || activeLocation)
    ) {
      return filteredRoofers.map(createMarker(selectedRoofer));
    }

    return pagedFilteredRoofers.map(createMarker(selectedRoofer));
  }, [selectedRoofer, pagedFilteredRoofers, showResultList]);
};

export default useMarkers;
